<template>
    <div class="mine">
        <mine-header :userInfo="userCenterInfo"></mine-header>
        <div class="mine-position-size">
            <mine-function :userInfo="userCenterInfo"></mine-function>
            <div style="height: 10px"></div>
            <mine-serve></mine-serve>
            <div style="height: 10px"></div>
            <!-- <van-button type="info" block color="#fff" @click="appDownload"><span class="appDownload">APP下载</span></van-button>
            <div style="height: 10px"></div> -->
            <van-button v-if='tokenIsUseful == 1' type="info" block color="#fff" @click="loginOut"><span class="loginOut">退出登录</span></van-button>
        </div>

        <Dialog :show.sync="showDialog" @hideDialog="showDialog = false" @handleLeftBtn="hideDialog" @handleConfirm="handleConfirm" leftBtnText="取消" rightBtnText="确认" content="是否退出登录？" />
    </div>
</template>

<script>
import MineHeader from "@/components/mine/mine-header.vue";
import MineFunction from "@/components/mine/mine-function.vue";
import MineServe from "@/components/mine/mine-serve.vue";
import Dialog from "@/components/base/dialog/dialog.vue";
import { queryBindPlateNumAndCouponNum } from "@/api/api";
import WarningLogin from "@/components/base/warning-login.vue";
import { mapGetters } from "vuex";

export default {
    name: "Mine",
    components: {
        MineHeader,
        MineFunction,
        MineServe,
        Dialog,
        WarningLogin,
    },
    data() {
        return {
            userInfo: {},
            userCenterInfo: {},
            showDialog: false,
        };
    },
    computed: {
        ...mapGetters({ tokenIsUseful: "tokenIsUseful" }),
    },
    mounted() {
        if (!this.tokenIsUseful) return
        this.getUserCenterInfo();
    },
    methods: {
        // 获取用户中心信息
        getUserCenterInfo() {
            queryBindPlateNumAndCouponNum({ type: 1 }).then((res) => {
                this.userCenterInfo = res.data;
            });
        },
        // 退出登录
        loginOut() {
            this.showDialog = true;
        },
        //取消登出
        hideDialog() {
            this.showDialog = false;
        },
        //确认登出
        handleConfirm() {
            this.showDialog = false;
            this.$store.dispatch("handleLogOut").then((res) => {
                wx.miniProgram.redirectTo({
                    url: `/pages/login/login?type=loginout`,
                });
            });
        },
        // app下载
        appDownload() {
            window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.linewell.zhangzhoupark";
        },
    },
};
</script>

<style lang="less" scoped>
@import url("~@/assets/style/color.less");
.mine {
    height: calc(~"100vh  - 88px");

    overflow: auto;
    background-color: #f5f8fa;
    .mine-position-size {
        margin-top: 26px;
        padding: 0 24px;
    }
    .loginOut {
        color: @main-color;
    }
    .appDownload {
        color: #999;
        font-size: 26px;
    }
}
</style>
